module.exports = __webpack_public_path__ + "static/media/icon-telephone.6b00c402.svg";